module.exports = __webpack_public_path__ + "img/1439624236.bb465976.jpg";